const state = {
    complexity: 'simple', // simple, more-complex, complex
    complexityHover: null,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  setComplexity(state, complexity) {
    state.complexity = complexity
  },
  setComplexityHover(state, complexityHover) {
    state.complexityHover = complexityHover
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}